import React, { useState, useEffect } from "react";
import Personal from "./formularios/personal";
import Contacto from "./formularios/contacto";
import Academico from "./formularios/academico";
import Carrera from "./formularios/carrera";
import Final from "./formularios/final";
import logo from "./img/logo-admision-cft.png";
import fondo from "./img/fondo-admision-2026.jpg";
import ModalPrematriculado from "./formularios/prematriculado";
import area_administracion from "./img/admision-2026-1.jpg";
import area_educacion from "./img/admision-2026-2.jpg";
import area_salud from "./img/admision-2026-3.jpg";
import area_social from "./img/admision-2026-4.jpg";
import area_tecnologia from "./img/admision-2026-5.jpg";


import {
  base64DecodeUnicode,
  base64EncodeUnicode,
  prepararUrl,
} from "../../_helpers";

//Libreria del validador del Rut
import { validate, clean, format, getCheckDigit } from "rut.js";
//Libreria alertas
import { showToastMessageError, showToastMessageSuccess } from "../toast";

//Objeto
const initialState = {
  rut: "",
  dv: "",
  fechanac: "",
  nombres: "",
  primerapellido: "",
  segundoapellido: "",
  genero: "",
  nacionalidad: "",
  region_residencia: "",
  comuna_residencia: "",
  residencia: "",
  telefono: "",
  conftelefono: "",
  email: "",
  confemail: "",
  nombre_emergencia: "",
  telefono_emergencia: "",
  region: "",
  comuna: "",
  colegio: "",
  situacion_actual: "",
  carrera: "",
  jornada: "",
};

function Home() {
  //Le agregue 1 para que ingrese de inmediato a ese formulario
  //useState = Hook
  const [etapas, setEtapas] = useState(1);
  const [state, setState] = useState(initialState);
  const [error, setError] = useState({});
  const [comuna_residencia, setComunaResidencia] = useState([]);
  const [nacionalidades, setNacionalidades] = useState([]);
  const [regiones, setRegiones] = useState([]);
  const [comuna_academico, setComunaAcademico] = useState([]);
  const [colegios, setColegios] = useState([]);
  const [carreras, setCarreras] = useState([
  ]);
  const [generos, setGeneros] = useState([])
  const [jornadas, setJornadas] = useState([
  ]);
  const [visible, setVisible] = useState("Mostrar");
  const [guardando, setGuardando] = useState(false);
  const [situacion_actual, setSituacionActual] = useState([
    //{ codsituacion: 1, descripcion: "Primero Medio" },
  ]);
  const [tipo_residencia, setTipoResidencia] = useState([]);
  const [scroll, setScroll] = useState(0);

  const toggleVisibility = () => {
    setVisible(!visible);
  };

  //Condiciones del Estudiante
  const [desactivaCondicones, setDesactivaCondiciones] = useState(1);
  const [CheckedCondiciones, setIsChecked] = useState(false);
  //Estudios Extranjeros
  const [desactivaEstudiosExtr, setDesactivaEstudiosExtr] = useState(1);
  const [checkedEstudiosExtr, setIsCheckedEstudiosExtr] = useState(false);

  window.onscroll = function () {
    let y = window.scrollY;
    //console.log(y);
    setScroll(y);
  };

  const handleChangeChbxCondiciones = (event) => {
    setIsChecked(event.target.checked);

    if (event.target.checked === false) {
      setDesactivaCondiciones(1);
    } else if (event.target.checked === true) {
      setDesactivaCondiciones(2);
    }
  };

  const _handleChangeChbxEstudiosExtr = (event) => {
    setIsCheckedEstudiosExtr(event.target.checked);

    if (event.target.checked === false) {
      setDesactivaEstudiosExtr(1);
    } else if (event.target.checked === true) {
      setDesactivaEstudiosExtr(2);
    }
  };

  //Validar input obligatorios
  const handleChangeError = (name) => {
    setError((prev) => {
      if (!(name in prev)) return prev;
      const updated = { ...prev };
      delete updated[name];
      return updated;
    });
  };

  const _handleChangeSoloNum = (e) => {
    const { name, value } = e.target;
    const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");
    setState((prevState) => ({
      ...prevState,
      [name]: removeNonNumeric(value),
    }));
    handleChangeError(name);
  };

  //Validar número en campo rut
  const _handleOnChangeNum = (e) => {
    const { name, value } = e.target;

    if (state.rut.length === 0 && value === "0") return false;

    const removeNonNumeric = (num) => num.toString().replace(/[^0-9]/g, "");

    setState((prevState) => ({
      ...prevState,
      [name]: removeNonNumeric(value),
      dv: removeNonNumeric(value) ? getCheckDigit(removeNonNumeric(value)) : "",
    }));

    //Para cuando escriben valores en las cajas, elimina indicación de que falta completar campo
    handleChangeError(name);
  };

  //Validar campos de textos
  const _handleOnChangeText = (e) => {
    const { name, value } = e.target;

    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    //Para cuando escriben valores en las cajas, elimina indicación de que falta completar campo
    handleChangeError(name);
  };

  async function _handleClickGuardarInscripcion() {
    if (etapas === 4) {
      if (!validateFormCarrera()) {
        showToastMessageError("Verifique campos");
        return false;
      }
    }

    setGuardando(true);

    try {
      const requestOptions = {
        method: "POST",
        body: JSON.stringify(state),
      };

      let v_url = prepararUrl("prematricula", "backend", "generales", "8");

      const response = await window.fetch(v_url, requestOptions);
      const resp = await response.json();

      if (response.ok) {
        //console.log(JSON.stringify(resp,null,3));
        showToastMessageSuccess(resp.message);
        setState(initialState);
        setEtapas(5);
        toggleVisibility("Ocultar");
        setGuardando(false);
      } else {
        if (response.status === 400) {
          showToastMessageError(resp.message);
          setError(resp.errores);
          setGuardando(false);
        }
      }
    } catch (error) {
      setGuardando(false);
    }
  }

  async function getListasOpciones() {
    try {
      const requestOptions = {
        method: "GET",
      };

      let v_url = prepararUrl("prematricula", "backend", "generales", "17", []);

      const response = await window.fetch(v_url, requestOptions);
      const resp = await response.json();

      if (response.ok) {
        let v_nacionalidades = resp.data.nacionalidades;
        let v_regiones = resp.data.regiones;
        let v_generos = resp.data.generos;
        let v_situacion_actual = resp.data.situacion_actual;
        let v_carreras = resp.data.carreras;
        let v_jornadas = resp.data.jornadas;
        let v_residencia = resp.data.tipo_residencia;

        setTipoResidencia(v_residencia);
        setNacionalidades([...v_nacionalidades]);
        setRegiones([...v_regiones]);
        setGeneros([...v_generos]);
        setSituacionActual([...v_situacion_actual]);
        setCarreras([...v_carreras]);
        setJornadas([...v_jornadas]);
      } else {
      }
    } catch (error) {

    }finally{
    }
  }

  async function getComunaResidencia() {
    try {
      const requestOptions = {
        method: "GET",
      };

      let v_url = prepararUrl("prematricula", "backend", "generales", "2", [
        { name: "codregion", value: state.region_residencia },
      ]);

      const response = await window.fetch(v_url, requestOptions);
      const resp = await response.json();

      if (response.ok) {
        let v_comuna_residencia = resp.data;
        setComunaResidencia(v_comuna_residencia);
      } else {
      }
    } catch (error) {}
  }

  async function getComunaAcademico() {
    //console.log(state.region);
    //return false;

    try {
      const requestOptions = {
        method: "GET",
      };

      let v_url = prepararUrl("prematricula", "backend", "generales", "2", [
        { name: "codregion", value: state.region },
      ]);

      const response = await window.fetch(v_url, requestOptions);
      const resp = await response.json();

      if (response.ok) {
        let v_comuna_academico = resp.data;
        setComunaAcademico(v_comuna_academico);
        //console.log(JSON.stringify(resp.data,null,3));
      } else {
      }
    } catch (error) {}
  }

  async function getColegios() {

    try {
      const requestOptions = {
        method: "GET",
      };

      let v_url = prepararUrl("prematricula", "backend", "generales", "5", [
        { name: "codcom", value: state.comuna },
      ]);

      const response = await window.fetch(v_url, requestOptions);
      const resp = await response.json();

      if (response.ok) {
        let v_colegios = resp.data;
        setColegios(v_colegios);
      } else {
      }
    } catch (error) {}
  }

  /*

*/
  //Validaciones de formularios
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const validateFormPersonal = () => {
    let field = state;
    let error = {};
    let formValid = true;
    
    if (!field.rut) {
      formValid = false;
      error["rut"] = "Ingrese RUT";
    }
    if (!field.fechanac) {
      formValid = false;
      error["fechanac"] = "Ingrese Fecha Nacimiento";
    }
    if (!field.nombres) {
      formValid = false;
      error["nombres"] = "Ingrese Nombres";
    }
    if (!field.primerapellido) {
      formValid = false;
      error["primerapellido"] = "Ingrese Primer Apellido";
    }
    if (!field.genero) {
      formValid = false;
      error["genero"] = "Seleccione Genero";
    }
    if (!field.nacionalidad) {
      formValid = false;
      error["nacionalidad"] = "Seleccione Nacionalidad";
    }
    if (!field.region_residencia) {
      formValid = false;
      error["region_residencia"] = "Seleccione Región";
    }

    if (!field.comuna_residencia) {
      formValid = false;
      error["comuna_residencia"] = "Seleccione Comuna";
    }

    if (field.nacionalidad > 56) {
      if (!field.residencia) {
        formValid = false;
        error["residencia"] = "Seleccione Tipo de Residencia";
      }
    }

    setError(error);
    return formValid;
  };

  const validateFormContacto = () => {
    let field = state;
    let error = {};
    let formValid = true;

    if (!field.telefono) {
      formValid = false;
      error["telefono"] = "Ingrese Teléfono Celular";
    }
    if (!field.conftelefono) {
      formValid = false;
      error["conftelefono"] = "Confirme Teléfono Celular";
    }

    if (!field.email) {
      formValid = false;
      error["email"] = "Ingrese Email";
    } else {
      if (!isValidEmail(field.email)) {
        formValid = false;
        error["email"] = "Email inválido";
      }
    }

    if (!field.confemail) {
      formValid = false;
      error["confemail"] = "Confirme Email";
    } else {
      if (!isValidEmail(field.confemail)) {
        formValid = false;
        error["confemail"] = "Email inválido";
      }
    }

    if (field.telefono != field.conftelefono) {
      formValid = false;
      error["telefono"] = "Teléfonos distintos";
      error["conftelefono"] = "Teléfonos distintos";
    }

    if (field.email != field.confemail) {
      formValid = false;
      error["email"] = "Email distintos";
      error["confemail"] = "Email distintos";
    }

    if (!field.nombre_emergencia) {
      formValid = false;
      error["nombre_emergencia"] = "Ingrese Nombre Emergencia";
    }

    if (!field.telefono_emergencia) {
      formValid = false;
      error["telefono_emergencia"] = "Ingrese Teléfono Emergencia";
    }

    if (field.telefono_emergencia == field.telefono) {
      formValid = false;
      error["telefono_emergencia"] =
        "Teléfono Emergencia debe ser distinto al de Contacto";
    }

    setError(error);
    return formValid;
  };

  const validateFormAcademico = () => {
    let field = state;
    let error = {};
    let formValid = true;

    if (!field.region && desactivaEstudiosExtr === 1) {
      formValid = false;
      error["region"] = "Seleccione Región";
    }
    if (!field.comuna && desactivaEstudiosExtr === 1) {
      formValid = false;
      error["comuna"] = "Seleccione Comuna";
    }
    if (!field.colegio && desactivaEstudiosExtr === 1) {
      formValid = false;
      error["colegio"] = "Seleccione Colegio";
    }
    if (!field.situacion_actual) {
      formValid = false;
      error["situacion_actual"] = "Seleccione Año";
    }
    setError(error);
    return formValid;
  };

  const validateFormCarrera = () => {
    let field = state;
    let error = {};
    let formValid = true;

    if (!field.carrera) {
      formValid = false;
      error["carrera"] = "Seleccione Carrera";
    }

    if (!field.jornada) {
      formValid = false;
      error["jornada"] = "Seleccione Jornada";
    }

    setError(error);
    return formValid;
  };

  //Funciones para etapas
  function SiguienteEtapa() {
    if (etapas === 1) {
      if (!validateFormPersonal()) {
        showToastMessageError("Verifique campos");
        return false;
      }
    }
    if (etapas === 2) {
      if (!validateFormContacto()) {
        showToastMessageError("Verifique campos");
        return false;
      }
    }
    if (etapas === 3) {
      if (!validateFormAcademico()) {
        showToastMessageError("Verifique campos");
        return false;
      }
    }
    setEtapas(etapas + 1);
  }

  function DevolverEtapa() {
    setEtapas(etapas - 1);
  }

  function Porcentaje() {
    if (etapas === 1) {
      return "0%";
    } else if (etapas === 2) {
      return "30%";
    } else if (etapas === 3) {
      return "60%";
    } else if (etapas === 4) {
      return "100%";
    }
  }

  function HabilitaCondiciones() {
    if (desactivaCondicones === 1) {
      return "disabled";
    } else {
      return "";
    }
  }

  //Botones para formularios
  const BtnAtras = () => {
    return (
      <>
        <div className="col-auto">
          <button
            type="button"
            className="btn btn-gris"
            onClick={DevolverEtapa}
          >
            Atrás
          </button>
        </div>
      </>
    );
  };

  const BtnSiguiente = () => {
    return (
      <>
        <button type="button" className="btn btn-azul" onClick={SiguienteEtapa}>
          Siguiente
        </button>
      </>
    );
  };

  const BtnEnviar = () => {
    return (
      <button
        type="button"
        className="btn btn-azul"
        disabled={guardando || HabilitaCondiciones()}
        onClick={() => _handleClickGuardarInscripcion()}
      >
        {guardando ? "Enviando..." : "Enviar"}
      </button>
    );
  };

  const ChkCondiciones = () => {
    return (
      <>
        <input
          className="form-check-input"
          type="checkbox"
          id="condiciones"
          name="condiciones"
          onChange={handleChangeChbxCondiciones}
          checked={CheckedCondiciones}
        />
        &nbsp;&nbsp;Acepto que conforme a lo estipulado en la ley N°19.628
        autorizo al almacenamiento de datos personales y su utilización en lo
        que la entidad estime pertinente, en resguardo siempre de la vida
        privada de los involucrados.
      </>
    );
  };

  const WarningExtranjero = () => {
    return (
      <div className="alert alert-warning" role="alert">
        <b>Importante:</b> Los extranjeros y chilenos que hubiesen terminado su
        enseñanza media en otro país deben cumplir con los procedimientos
        establecidos para el reconocimiento de sus estudios en Chile. Todo
        postulante extranjero debe tener permanencia definitiva en Chile, salvo
        las excepciones que establezca el Reglamento de Admisión.
      </div>
    );
  };

  //Trigger que se ejecuta cuando se renderiza el componente en navegador
  useEffect(() => {

    getListasOpciones()
  }, []);

  //Personal
  useEffect(() => {
    if (state.region_residencia) {
      getComunaResidencia();
    }
  }, [state.region_residencia]);

  //Académico
  useEffect(() => {
    if (state.region) {
      getComunaAcademico();
    }
  }, [state.region]);

  useEffect(() => {
    if (state.comuna) {
      getColegios();
    }
  }, [state.comuna]);

  var sectionStyle = {
    backgroundSize: "cover",
    backgroundImage: `url(${fondo})`,
  };

  return (
    <>
      {visible && (
        <>
          <div className="min-vh-100 min-vw-100" style={sectionStyle}>
              <div className="row justify-content-center align-items-center vh-100">
                <div className="col-12 col-lg-5 d-none d-lg-block h-100 d-flex flex-column" >
                  <div className="container text-center h-100 d-flex flex-column justify-content-end pb-5">
                    <div className="row">
                      <h1 className="hero-title display-4 fw-bold mb-4 text-white">
                        Pre Matrícula 100% Online                       </h1>
                      <h4 className="hero-subtitle fw-light mb-0 text-white">
                        ¡Ya puedes reservar tu cupo para estudiar con nosotros!
                      </h4>
                    </div>
                    </div>
                </div>
                <div className="col-12 col-lg-6 h-100 d-flex align-items-center justify-content-center">
                  <div className="form-panel bg-white shadow-lg">
                    <div className="form-header text-center p-2 border-bottom">
                      <div className="logo-container">
                        <img
                          src={logo}
                          height="140px"
                          className="logo-img"
                          alt="Logo CFT"
                        />
                      </div>
                      {/* <h4 className="form-title fw-bold text-dark mb-2">
                        Proceso de Admisión 2026
                      </h4>
                      <p className="form-subtitle text-muted mb-0">
                        Formulario de Pre Matrícula
                      </p> */}
                    </div>
                    <div className="form-body p-4">
                      <div className="progress-container mb-4">
                        <div className="progress progress-custom">
                          <div
                            className="progress-bar progress-bar-custom"
                            role="progressbar"
                            style={{ width: Porcentaje() }}
                            aria-valuenow="0"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                        <div className="progress-text text-center mt-2">
                          <small className="text-muted">Paso {etapas} de 4</small>
                        </div>
                      </div>

                      <div className="form-content">
                      {etapas === 1 && nacionalidades.length>0 && (
                          <Personal
                            regiones={regiones}
                            comuna_residencia={comuna_residencia}
                            nacionalidades={nacionalidades}
                            generos={generos}
                            tipo_residencia={tipo_residencia}
                            handleOnChangeNum={_handleOnChangeNum}
                            state={state}
                            handleOnChangeText={_handleOnChangeText}
                            error={error}
                          />
                        )}
                        {etapas === 2 && (
                          <Contacto
                            state={state}
                            handleOnChangeText={_handleOnChangeText}
                            error={error}
                            handleChangeSoloNum={_handleChangeSoloNum}
                          />
                        )}
                        {etapas === 3 && (
                          <Academico
                            regiones={regiones}
                            comuna_academico={comuna_academico}
                            colegios={colegios}
                            situacion_actual={situacion_actual}
                            state={state}
                            handleOnChangeText={_handleOnChangeText}
                            handleChangeChbxEstudiosExtr={
                              _handleChangeChbxEstudiosExtr
                            }
                            CheckedEstudiosExtranjero={checkedEstudiosExtr}
                            error={error}
                          />
                        )}
                        {etapas === 4 && (
                          <Carrera
                            carreras={carreras}
                            jornadas={jornadas}
                            state={state}
                            handleOnChangeText={_handleOnChangeText}
                            error={error}
                          />
                        )}
                      </div>

                      {etapas === 4 && (
                        <div className="stage-4-elements">
                          <div className="conditions-section mb-3">
                            <ChkCondiciones />
                          </div>
                          <div className="warning-section mb-3">
                            {((state.nacionalidad === "1" &&
                              checkedEstudiosExtr === true) ||
                              state.nacionalidad != "1") && (
                              <WarningExtranjero />
                            )}
                          </div>
                        </div>
                      )}

                      <div className="navigation-buttons mt-4 pt-3 border-top">
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            {etapas > 1 && <BtnAtras />}
                          </div>
                          <div>
                            {etapas === 4 ? <BtnEnviar /> : <BtnSiguiente />}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>


        </>
      )}

      {etapas === 5 && <Final state={state} />}
      {etapas === 5 && <ModalPrematriculado />}

      <div className="display-6 fw-bold text-center mt-5 mb-4">
          <span className="text-primary">Carreras Técnicas de Nivel Superior</span>
      </div>

      <div className="container-fluid" style={{ padding: "2rem 1rem" }}>
        <div className="row g-4 justify-content-center">
          {/* Área Administración */}
          <div className="col-12 col-sm-6 col-lg-4 col-xl-2">
            <div className="card area-card h-100 shadow-sm">
              <div
                className="card-img-top d-block d-lg-none"
                style={{
                  height: "300px",
                  backgroundImage: `url(${area_administracion})`,
                  backgroundSize: "cover",
                  backgroundPosition: "50% 20%",
                  position: "relative"
                }}
              >
                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center pb-3"
                     style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}>
                  <h4 className="text-white fw-bold text-center mb-0">
                    <i className="fas fa-briefcase me-2"></i>
                    Administración y Comercio
                  </h4>
                </div>
              </div>

              <div
                className="card-img-top d-none d-lg-block"
                style={{
                  height: "200px",
                  backgroundImage: `url(${area_administracion})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  position: "relative"
                }}
              >
                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center pb-3"
                     style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}>
                  <h4 className="text-white fw-bold text-center mb-0">
                    <i className="fas fa-briefcase me-2"></i>
                    Administración y Comercio
                  </h4>
                </div>
              </div>
              <div className="card-body d-flex flex-column">
                <div className="mt-auto">
                  <div className="d-grid gap-2">
                    <a
                      className="btn btn-outline-primary btn-sm"
                      target="_blank"
                      href="https://www.cftestataltarapaca.cl/admision/tns-administracion-empresas/" rel="noreferrer"
                    >
                      TNS en Administración de Empresas
                    </a>
                    <a
                      className="btn btn-outline-primary btn-sm"
                      target="_blank"
                      href="https://www.cftestataltarapaca.cl/admision/tns-administracion-publica/" rel="noreferrer"
                    >
                      TNS en Administración Pública
                    </a>
                    <a
                      className="btn btn-outline-primary btn-sm"
                      target="_blank"
                      href="https://www.cftestataltarapaca.cl/admision/tns-comercio-exterior/" rel="noreferrer"
                    >
                      TNS Comercio Exterior
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Área Educación */}
          <div className="col-12 col-sm-6 col-lg-4 col-xl-2">
            <div className="card area-card h-100 shadow-sm">
              <div
                className="card-img-top d-block d-lg-none"
                style={{
                  height: "300px",
                  backgroundImage: `url(${area_educacion})`,
                  backgroundSize: "cover",
                  backgroundPosition: "50% 20%",
                  position: "relative"
                }}
              >
                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center pb-3"
                     style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}>
                  <h4 className="text-white fw-bold text-center mb-0">
                    <i className="fas fa-graduation-cap me-2"></i>
                    Educación
                  </h4>
                </div>
              </div>

              <div
                className="card-img-top d-none d-lg-block"
                style={{
                  height: "200px",
                  backgroundImage: `url(${area_educacion})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  position: "relative"
                }}
              >
                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center pb-3"
                     style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}>
                  <h4 className="text-white fw-bold text-center mb-0">
                    <i className="fas fa-graduation-cap me-2"></i>
                    Educación
                  </h4>
                </div>
              </div>
              <div className="card-body d-flex flex-column">
                <div className="mt-auto">
                  <div className="d-grid gap-2">
                    <a
                      className="btn btn-outline-primary btn-sm"
                      target="_blank"
                      href="https://www.cftestataltarapaca.cl/admision/tns-asistente-educacion/" rel="noreferrer"
                    >
                      TNS Asistente de la Educación
                    </a>
                    <a
                      className="btn btn-outline-primary btn-sm"
                      target="_blank"
                      href="https://www.cftestataltarapaca.cl/admision/tns-educacion-parvularia/" rel="noreferrer"
                    >
                      TNS en Educación Parvularia
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Área Salud */}
          <div className="col-12 col-sm-6 col-lg-4 col-xl-2">
            <div className="card area-card h-100 shadow-sm">
              <div
                className="card-img-top d-block d-lg-none"
                style={{
                  height: "300px",
                  backgroundImage: `url(${area_salud})`,
                  backgroundSize: "cover",
                  backgroundPosition: "50% 20%",
                  position: "relative"
                }}
              >
                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center pb-3"
                     style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}>
                  <h4 className="text-white fw-bold text-center mb-0">
                    <i className="fas fa-heartbeat me-2"></i>
                    Salud
                  </h4>
                </div>
              </div>

              <div
                className="card-img-top d-none d-lg-block"
                style={{
                  height: "200px",
                  backgroundImage: `url(${area_salud})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  position: "relative"
                }}
              >
                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center pb-3"
                     style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}>
                  <h4 className="text-white fw-bold text-center mb-0">
                    <i className="fas fa-heartbeat me-2"></i>
                    Salud
                  </h4>
                </div>
              </div>
              <div className="card-body d-flex flex-column">
                <div className="mt-auto">
                  <div className="d-grid gap-2">
                    <a
                      className="btn btn-outline-primary btn-sm"
                      target="_blank"
                      href="https://www.cftestataltarapaca.cl/admision/tns-enfermeria/" rel="noreferrer"
                    >
                      TNS Enfermería
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Área Tecnología */}
          <div className="col-12 col-sm-6 col-lg-4 col-xl-2">
            <div className="card area-card h-100 shadow-sm">
              <div
                className="card-img-top d-block d-lg-none"
                style={{
                  height: "300px",
                  backgroundImage: `url(${area_tecnologia})`,
                  backgroundSize: "cover",
                  backgroundPosition: "50% 20%",
                  position: "relative"
                }}
              >
                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center pb-3"
                     style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}>
                  <h4 className="text-white fw-bold text-center mb-0">
                    <i className="fas fa-cogs me-2"></i>
                    Tecnología
                  </h4>
                </div>
              </div>

              <div
                className="card-img-top d-none d-lg-block"
                style={{
                  height: "200px",
                  backgroundImage: `url(${area_tecnologia})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  position: "relative"
                }}
              >
                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center pb-3"
                     style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}>
                  <h4 className="text-white fw-bold text-center mb-0">
                    <i className="fas fa-cogs me-2"></i>
                    Tecnología
                  </h4>
                </div>
              </div>
              <div className="card-body d-flex flex-column">
                <div className="mt-auto">
                  <div className="d-grid gap-2">
                    <a
                      className="btn btn-outline-primary btn-sm"
                      target="_blank"
                      href="https://www.cftestataltarapaca.cl/admision/tns-electricidad-industrial/" rel="noreferrer"
                    >
                      TNS en Electricidad Industrial
                    </a>
                    <a
                      className="btn btn-outline-primary btn-sm"
                      target="_blank"
                      href="https://www.cftestataltarapaca.cl/admision/tns-logistica/" rel="noreferrer"
                    >
                      TNS en Logística
                    </a>
                    <a
                      className="btn btn-outline-primary btn-sm"
                      target="_blank"
                      href="https://www.cftestataltarapaca.cl/admision/tns-mecanico-mantenimiento-predictivo/" rel="noreferrer"
                    >
                      TNS Mecánico en Mantenimiento Predictivo
                    </a>
                    <a
                      className="btn btn-outline-primary btn-sm"
                      target="_blank"
                      href="https://www.cftestataltarapaca.cl/admision/tns-mineria/" rel="noreferrer"
                    >
                      TNS en Minería
                      <span className="badge bg-warning text-dark ms-2">Carrera Nueva</span>
                    </a>
                    <a
                      className="btn btn-outline-primary btn-sm"
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.cftestataltarapaca.cl/admision/tns-informatica/"
                    >
                      TNS en Informática
                      <span className="badge bg-warning text-dark ms-2">Carrera Nueva</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Área Servicios Sociales */}
          <div className="col-12 col-sm-6 col-lg-4 col-xl-2">
            <div className="card area-card h-100 shadow-sm">
              <div
                className="card-img-top d-block d-lg-none"
                style={{
                  height: "300px",
                  backgroundImage: `url(${area_social})`,
                  backgroundSize: "cover",
                  backgroundPosition: "50% 20%",
                  position: "relative"
                }}
              >
                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center pb-3"
                     style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}>
                  <h4 className="text-white fw-bold text-center mb-0">
                    <i className="fas fa-hands-helping me-2"></i>
                    Servicios Sociales
                  </h4>
                </div>
              </div>

              <div
                className="card-img-top d-none d-lg-block"
                style={{
                  height: "200px",
                  backgroundImage: `url(${area_social})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  position: "relative"
                }}
              >
                <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-end justify-content-center pb-3"
                     style={{ backgroundColor: "rgba(0, 0, 0, 0.3)" }}>
                  <h4 className="text-white fw-bold text-center mb-0">
                    <i className="fas fa-hands-helping me-2"></i>
                    Servicios Sociales
                  </h4>
                </div>
              </div>
              <div className="card-body d-flex flex-column">
                <div className="mt-auto">
                  <div className="d-grid gap-2">
                    <a
                      className="btn btn-outline-primary btn-sm"
                      target="_blank"
                      href="https://www.cftestataltarapaca.cl/admision/tns-trabajo-social/" rel="noreferrer"
                    >
                      TNS Trabajo Social
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>


      </div>



      <div
        className="footer col-lg-12 col-xl-12 mx-auto pb-3"

      >
        <p className="text-center text-white mb-0">
          <br />
          <strong>Estamos en Juanita Fernández 3199, Alto Hospicio.</strong>
          <br />
          Mail: <a href="mailto:admision@cftestataltarapaca.cl" className="text-white">admision@cftestataltarapaca.cl</a> –
          Teléfonos: <a href="tel:+56572267570" className="text-white">57 226 7570</a> –
          <a href="tel:+56572267574" className="text-white">57 226 7574</a> –
          Whatsapp: <a href="https://wa.me/56978953861" className="text-white">+56 9 7895 3861</a>
        </p>
        <p className="text-center text-white mt-2 mb-0">
          Horarios de Atención: <strong >Lunes a jueves</strong> 8:30 a 17:30 hrs. | <strong >Viernes</strong> 8:30 a 16:30 hrs.
        </p>
      </div>
      <div
        className="footer col-lg-12 col-xl-12 mx-auto"
        style={{ height: "60px", backgroundColor: "#247cbb" }}
      >

<ul className="nav justify-content-center text-center pt-2" id="social">
            <li className="nav-item">
              <a
                target="_blank"
                href="https://www.twitter.com/cftestarapaca"
                className="nav-link px-2 text-muted d-flex align-items-center" rel="noreferrer"
              >
                <i className="fab fa-twitter social-icon"></i>
                <label className="ms-4 text-white ocultarCel social-label ps-1">Twitter</label>
              </a>
            </li>
            <li className="nav-item">
              <a
                target="_blank"
                href="https://www.facebook.com/CFTestataltarapaca"
                className="nav-link px-2 text-muted d-flex align-items-center" rel="noreferrer"
              >
                <i className="fab fa-facebook-f social-icon"></i>
                <label className="ms-4 text-white ocultarCel social-label ps-1">Facebook</label>
              </a>
            </li>
            <li className="nav-item">
              <a
                target="_blank"
                href="https://www.linkedin.com/company/cft-estatal-tarapaca/"
                className="nav-link px-2 text-muted d-flex align-items-center" rel="noreferrer"
              >
                <i className="fab fa-linkedin-in social-icon"></i>
                <label className="ms-4 text-white ocultarCel social-label ps-1">LinkedIn</label>
              </a>
            </li>
            <li className="nav-item">
              <a
                target="_blank"
                href="https://www.youtube.com/cftestataltarapaca"
                className="nav-link px-2 text-muted d-flex align-items-center" rel="noreferrer"
              >
                <i className="fab fa-youtube social-icon"></i>
                <label className="ms-4 text-white ocultarCel social-label ps-1">YouTube</label>
              </a>
            </li>
            <li className="nav-item">
              <a
                target="_blank"
                href="https://www.instagram.com/cftestataltarapaca/"
                className="nav-link px-2 text-muted d-flex align-items-center" rel="noreferrer"
              >
                <i className="fab fa-instagram social-icon"></i>
                <label className="ms-4 text-white ocultarCel social-label ps-1">Instagram</label>
              </a>
            </li>
          </ul>
      </div>
    </>
  );
}

export default Home;
